module.exports = __webpack_public_path__ + "static/shoe-layers-1-142328f8e2db09c590bdec64f4f5286a.png";